import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import logo from './logo.svg';
import { 
  HomePage, 
  LoginPage, 
  LandingPage,
  Dashboard,
  Diagnosis,
  Slides,
  Patients,
  Cases,
  Users, 
  LabHome,
  Screening,
  PrivacyPolicy,
  Simulations_Privacy,
  Specialities,
  PatientChart,
  HBPPatientCases,
  ManualSub,
  Plans,
  Feature,
  Chat,
  ActionLogs,
  Products,
  TagsCategoryPage,
  FacilityTags,
  Facility,
  FacilityServies,
  FacilityTypes,
  AdsPage,
  FacilityMaps,
  Insurance,
  MedicationPage,
  LabTestPage,
  RadiologyExamPage,
  FacilityDetailsPage
} from './pages';
import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase/firebase-config';
import 'react-toastify/dist/ReactToastify.css';
import Protected from './components/form/Protected';
import { useTranslation } from 'react-i18next';

function App() {
  const { t, i18n } = useTranslation();
  let [lang, setLang] = useState<any>(null);

  const handleTrans = () => {
    i18n.changeLanguage(lang);
  };

  const handleLangInit = () => {
    let lng = localStorage.getItem('locale');
    // console.log("locale", lng);
    if(lng == null) {
      localStorage.setItem('locale', 'en')
      setLang('en');
    }else {
      setLang(lng);
    }
  }

  const changeLang = () => {
    if(lang != null) {
      localStorage.setItem('locale', lang)
      handleTrans();
    }
  } 

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, loading, error] = useAuthState(auth);


  // useEffect(() => {
  //   if (loading) return;
  //   console.log('USER', user);
  //   if (user) return setIsLoggedIn(true)
  // }, [user, loading]);

  useEffect(() => {
    handleLangInit();
  },[])

  useEffect(() => {
    changeLang()
  }, [lang]);
  

  return loading ?<></> : (
    <div className="App">

      <BrowserRouter>
        <Routes>
            <Route path="/" element={(<Protected isLoggedIn={user}> <LandingPage /> </Protected>)} />
            <Route path="/dashboard" element={(<Protected isLoggedIn={user}> <Dashboard /> </Protected>)} />
            <Route path="/report" element={(<Protected isLoggedIn={user}> <Diagnosis /> </Protected>)} />
            <Route path="/slides" element={(<Protected isLoggedIn={user}> <Slides /> </Protected>)} />
            <Route path="/patients" element={(<Protected isLoggedIn={user}> <Patients /> </Protected>)} />
            <Route path="/patient-chart" element={(<Protected isLoggedIn={user}> <PatientChart /> </Protected>)} />
            <Route path="/hbp-cases" element={(<Protected isLoggedIn={user}> <HBPPatientCases /> </Protected>)} />
            <Route path="/users" element={(<Protected isLoggedIn={user}> <Users /> </Protected>)} />
            <Route path="/cases" element={(<Protected isLoggedIn={user}> <Cases /> </Protected>)} />
            <Route path="/shared" element={(<Protected isLoggedIn={user}> <LandingPage /> </Protected>)} />
            <Route path="/screening" element={(<Protected isLoggedIn={user}> <Screening /> </Protected>)} />
        
            <Route path="/specialities" element={(<Protected isLoggedIn={user}> <Specialities /> </Protected>)} />

            <Route path="/manual-subs" element={(<Protected isLoggedIn={user}> <ManualSub /> </Protected>)} />

            <Route path="/plans" element={(<Protected isLoggedIn={user}> <Plans /> </Protected>)} />
            <Route path="/features" element={(<Protected isLoggedIn={user}> <Feature /> </Protected>)} />
            
            <Route path="/products" element={(<Protected isLoggedIn={user}> <Products /> </Protected>)} />

            <Route path="/ads" element={(<Protected isLoggedIn={user}> <AdsPage /> </Protected>)} />

            <Route path="/tags-categories" element={(<Protected isLoggedIn={user}> <TagsCategoryPage /> </Protected>)} />
            <Route path="/facility-tags" element={(<Protected isLoggedIn={user}> <FacilityTags /> </Protected>)} />
            <Route path="/facilities" element={(<Protected isLoggedIn={user}> <Facility /> </Protected>)} />
            <Route path="/facility-services" element={(<Protected isLoggedIn={user}> <FacilityServies /> </Protected>)} />
            <Route path="/facility-types" element={(<Protected isLoggedIn={user}> <FacilityTypes /> </Protected>)} />
            <Route path="/insurances" element={(<Protected isLoggedIn={user}> <Insurance /> </Protected>)} />

            <Route path="/medications" element={(<Protected isLoggedIn={user}> <MedicationPage /> </Protected>)} />

            <Route path="/radiology-exam" element={(<Protected isLoggedIn={user}> <RadiologyExamPage /> </Protected>)} />


            <Route path="/labtests" element={(<Protected isLoggedIn={user}> <LabTestPage /> </Protected>)} />

            <Route path="/facility-map" element={(<Protected isLoggedIn={user}> <FacilityMaps /> </Protected>)} />

            <Route path="/action-logs" element={(<Protected isLoggedIn={user}> <ActionLogs /> </Protected>)} />
            <Route path="/chat" element={(<Protected isLoggedIn={user}> <Chat /> </Protected>)} />

            <Route path="/facilities/:id" element={(<Protected isLoggedIn={user}> <FacilityDetailsPage /> </Protected>)} />
            

            <Route path="/lab/home" element={(<Protected isLoggedIn={user}> <LabHome /> </Protected>)} />
            <Route path="/login" element={(<LoginPage />)} />
            <Route path="/privacy" element={(<PrivacyPolicy />)} />
            <Route path="/simulations/privacy" element={(<Simulations_Privacy />)} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default App;

